<button
    [class]="buttonClasses"
    [disabled]="disabled"
    (click)="clickHandler($event)"
    (mouseleave)="mouseLeaveHandler($event)"
    (mouseover)="mouseOverHandler($event)"
>
    <ng-content></ng-content>
</button>
